<div class="wrapper has-padding">

  <h1 class="bofa--heading is-1">
    <div>
      Session Expired !
    </div>
  </h1>

  <p>For your safety and protection your session has been timed out due to inactivity or by selecting save and finish
  later. </p>
  <p>Please sign in again to the application to resume your work. We apologize for any inconvenience that this may
  cause.</p>
  @if (!this.nhpToken || nhpToken === 'undefined') {
    <p>
      <a class="mat-list-item logout-text" href="javascript:void(0);" (click)="initiationUrl()">
        Click here to login
      </a>
    </p>
  }
</div>